<!-- template>
    <div>
        <form ref="form" data-url="#">
            <div class="form-group row align-items-center">
                <label for="inputs_email" class="col-sm-2 mb-0">{{ $t('email') }}</label>
                <app-input id="inputs_email"
                           class="col-sm-7"
                           type="email"
                           v-model="inputs.email"
                           :placeholder="$t('email_type_input')"
                           :required="true"
                />
            </div>
            <div class="form-group row align-items-center">
                <label for="inputs_phone" class="col-sm-2 mb-0">{{ $t('contact_number') }}</label>
                <app-input
                    id="inputs_phone"
                    class="col-sm-7"
                    type="tel-input"
                    v-model="inputs.phone"
                    :placeholder="$t('type_contact_number')"
                />
            </div>
            <br>
            <div class="form-group mt-3">
                <div class="row">
                    <div class="col-12">
                        <button
                            type="button"
                            @click.prevent="goBack"
                            class="btn btn-secondary mr-2">
                            {{ $t('back') }}
                        </button>
                        <button
                            type="button"
                            @click.prevent="goNext"
                            class="btn btn-primary">
                            {{ $t('next') }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template -->

<template>
  <div>
    <form ref="form" data-url="#">
      <label for="account-select" class="col-sm-2 mb-0">{{ $t('Select or create a GTM account:') }}</label>
      <app-input
          id="account-select"
          class="col-sm-7"
          type="select"
          :required="true"
          @change="loadContainers"
          v-model="selectedAccount"

      />
      <!--<select id="account-select" v-model="selectedAccount" @change="loadContainers">
        <option v-for="account in accounts" :key="account.accountId" :value="account.accountId">
          {{ account.name }}
        </option>
      </select>-->
      <br><br>
      <label for="container-select">Select or create a GTM container:</label>
      <select id="container-select" v-model="selectedContainer">
        <option v-for="container in containers" :key="container.containerId" :value="container.containerId">
          {{ container.name }}
        </option>
      </select>
      <br><br>
      <label for="json-file">Select a JSON file:</label>
      <input type="file" id="json-file" @change="handleFileChange">
      <br><br>
      <button @click="importJsonFile" :disabled="!selectedAccount || !selectedContainer || !selectedFile">
        Import JSON file
      </button>
    </form>
  </div>
</template>
  
  <script>
  import {FormMixin} from "../../../../../core/mixins/form/FormMixin";

  export default {
      mixins: [FormMixin],
      props: {
          dataCarry: {}
      },
      data() {
        return {
          accounts: [],
          selectedAccount: '',
          containers: [],
          selectedContainer: '',
          selectedFile: null,
        };
    },
    beforeCreate() {
      gapi.load('client:auth2', this.initGTM);
    },
    methods: {
      initGTM() {
        const apiKey = 'AIzaSyC6OGPEZ0SKY5JR09W97Np8W7T-Gn2INgg';
        const clientId = '193229075891-nnhgmsl2rdr3qa1u9fe875945bheqdn7.apps.googleusercontent.com';
        const discoveryDocs = ['https://www.googleapis.com/discovery/v1/apis/tagmanager/v2/rest'];
        const scope = 'https://www.googleapis.com/auth/tagmanager.edit.containers';

      gapi.client.init({ apiKey, clientId, discoveryDocs, scope })
        .then(() => gapi.auth2.getAuthInstance().signIn())
        .then(() => this.loadAccounts());
    },
    loadAccounts() {
      const self = this;
      gapi.client.tagmanager.accounts.list().execute(function(response) {
        self.accounts = response.result.account;
        self.selectedAccount = self.accounts.length > 0 ? self.accounts[0].accountId : '';
        self.loadContainers();
      });
    },
    loadContainers() {
      const accountId = this.selectedAccount;
      const self = this;

      gapi.client.tagmanager.accounts.containers.list({ accountId }).execute(function(response) {
        self.containers = response.result.container;
        self.selectedContainer = self.containers.length > 0 ? self.containers[0].containerId : '';
      });
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    importJsonFile() {
      const containerId = this.selectedContainer;
      const file = this.selectedFile;

      // Perform the import using the GTM API
      // You need to implement the necessary API calls here
    },
  },
};
</script>


<!-- script>
/*
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";

export default {
    mixins: [FormMixin],
    props: {
        dataCarry: {}
    },
    data() {
        return {
            inputs: {
                email: '',
                phone: ''
            }
        }
    },
    methods: {
        goBack() {
            this.$emit('back', true);
        },
        goNext() {
            this.fieldStatus = {};
            this.fieldStatus.isSubmit = true;
            if (this.isValidForm()) {
                this.$emit('next', true, this.inputs);
            }
        }
    }
}
*/
</script -->
